import { Component, Input, OnInit } from '@angular/core';
import { Annotation } from '../../models/Annotation';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { HttpcallService } from '../../services/httpcall.service';
import { SessionService } from '../../services/Session.service';

@Component({
  selector: 'app-annotation-records-print-prv',
  templateUrl: './annotation-records-print-prv.component.html'
})
export class AnnotationRecordsPrintPrvComponent implements OnInit {

  constructor(private loginService: LoginService, private httpCallService: HttpcallService,
    public commonDataService: CommonDataService, private graphQlService: GraphqlService, private clipboard: Clipboard,
    public dialog: MatDialog, private sessionService: SessionService) {
  }
  @Input() paragraphId: string = "";
  @Input() lineBool: string = "";
  @Input() UserInfo: any;
  shareLinkLabel: string;
  editLinkLabel: string;
  deleteLinkLabel: string;
  addedTextLabel: string;
  emailId: string = "";  
  annotationContent: Annotation[] = [];
  contentloaded: boolean = false;
  globalinfodata;
  
  ngOnInit(): void {    
    this.commonDataService.showLoader.next(true);
    this.getEmailId();
    this.getAnnotation();
   
    this.globalinfodata = this.sessionService.globallablesinfo;
    if (this.globalinfodata != null) {

      this.filterlabels(this.globalinfodata)
    } else {     
        this.getYourAnnotationLabel();
    }  

    this.commonDataService.updateAnnotationParagraphId.subscribe(data => {
      if (data == this.paragraphId) {
        this.getAnnotation();
      }
    })
    this.commonDataService.addAnnotationParagraphId.subscribe(data => {
      if (data == this.paragraphId) {
        this.getAnnotation();
      }
    })

    
  }
  filterlabels(data) {
    var labels = data.content.data.labels;
    labels = labels.filter(x => x.key.trim());
    this.shareLinkLabel = labels.filter(x => x.key == "global_share").map(y => y.value);
    this.editLinkLabel = labels.filter(x => x.key == "global_edit").map(y => y.value);
    this.deleteLinkLabel = labels.filter(x => x.key == "global_delete").map(y => y.value);
    this.addedTextLabel = labels.filter(x => x.key == "global_added").map(y => y.value);

  }
  getYourAnnotationLabel() {
    if (this.sessionService.globallablesinfo == null || this.sessionService.globallablesinfo == undefined) {
      this.graphQlService.getGlobalLabels().subscribe(data => {
        if (data != "") {
          this.sessionService.assignglobalinfo(data);
          this.filterlabels(data)

        }
      });
    }
    else {
      this.filterlabels(this.sessionService.globallablesinfo);
    }
  }

  getEmailId() {
    if (this.sessionService.userInfo == undefined || this.sessionService.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.commonDataService.emailId.next(data.user.email);
        this.emailId = data.user.email;
        this.getAnnotation();
        this.sessionService.assignUserInfo(data.user);
      })
    }
    else {
      this.emailId = this.sessionService.userInfo.user.email;
      this.getAnnotation();
    }
  }

  getAnnotation() {
    this.httpCallService.getAnnotation(this.paragraphId, "false").subscribe((resp: any) => {
      this.annotationContent = resp;
      setTimeout(() => {
        let str = `<div class="printBox">`;
        var hide = document.getElementsByClassName("print-content-hide")
        Array.prototype.forEach.call(hide, function (obj) {
          obj.style.display = "none"
        });
        var contents = document.getElementsByClassName("print-all-content");
        Array.prototype.forEach.call(contents, function (element) {
          str += `<div> ${element.innerHTML} </div>`;
        });
        str += '</div>'

        Array.prototype.forEach.call(hide, function (obj) {
          obj.style.display = "block";
        });

        setTimeout(() => {
          document.getElementById("printPreviewArticle").innerHTML = "";
          document.getElementById("printPreviewArticle").innerHTML += str;
          const pageHeading = document.getElementById("pageHeading");
          if (pageHeading?.innerHTML) {
            document.getElementById("pageHeadingprint").innerHTML = pageHeading.innerHTML;
          //} else {
          //  document.getElementById("pageHeaderLine").style.display = "none";
          }
          this.commonDataService.showLoader.next(false);
          this.commonDataService.printwithannotations.next("");
        }, 500)              
      }, 500)      
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

}
